import React from "react";
import { ReactComponent as HamburgerMenuIcon } from "svgs/hamburger-menu.svg";
import { trackClickHamburgerMenu } from "analytics";
import clsx from "clsx/lite";
import { useSettings } from "hooks/useStore";

const HamburgerMenu = ({ isOpen, embedHeader }) => {
	const { toggleMenu, toggleSearch, isSearchOpen } = useSettings(["toggleMenu", "toggleSearch", "isSearchOpen"]);
	const handleOnClick = () => {
		trackClickHamburgerMenu(isOpen ? "close" : "open");
		isSearchOpen ? toggleSearch() : toggleMenu();
	};

	return (
		<button id="hamburger-menu" className={clsx(isOpen ? "opened" : null, embedHeader && "invert")}
			onClick={handleOnClick} aria-label="Main Menu" aria-expanded={isOpen ? true : false}>
			<HamburgerMenuIcon />
		</button>
	);
};

export default HamburgerMenu;
